/**
 * Utilidades generales para formateo y conversión de datos
 */

/**
 * Formatea una duración en minutos a un string legible
 * @param minutes - Duración en minutos
 * @returns String formateado (ej: "1h 45min", "30min")
 * 
 * @example
 * formatDuration(105) // "1h 45min"
 * formatDuration(30) // "30min"
 * formatDuration(0) // "0min"
 */
export function formatDuration(minutes: number): string {
  if (minutes < 0) return '0min';
  
  const hours = Math.floor(minutes / 60);
  const mins = Math.round(minutes % 60);
  
  if (hours === 0) {
    return `${mins}min`;
  }
  
  if (mins === 0) {
    return `${hours}h`;
  }
  
  return `${hours}h ${mins}min`;
}

/**
 * Convierte un número decimal de hora (0-23.5) a formato time de PostgreSQL
 * @param departureTime - Hora en formato decimal (ej: 15.5 = 15:30)
 * @returns String en formato time (ej: "15:30:00")
 */
export function departureTimeToTime(departureTime: number): string {
  const hours = Math.floor(departureTime);
  const minutes = Math.round((departureTime % 1) * 60);
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}

/**
 * Convierte un formato time de PostgreSQL a número decimal
 * @param timeStr - Hora en formato time (ej: "15:30:00")
 * @returns Número decimal (ej: 15.5)
 */
export function timeToDepartureTime(timeStr: string): number {
  const [hours, minutes] = timeStr.split(':').map(Number);
  return hours + (minutes / 60);
}
